<template>
     <div class="form-group row">
        <slot name="label">
            <label class="col-form-label" :class="labelSizeClasses" v-if="label && label.length" :for="fieldId">{{label}}: </label>
        </slot>
        <slot name="control">
            <div :class="inputSizeClasses">
                <input class="form-control" :class="{'is-invalid': hasError}" type="number" :id="fieldId" :name="fieldName" v-model.number="inputValue" :disabled="disabled">
            </div>
        </slot>
    </div>
</template>

<script>
import inputField from './mixins/inputField';

export default {
	mixins: [inputField],
	slots: {
		value: Number
	},
	watch: {
		inputValue(val) {
			this.$emit('input', val !== '' ? val : null);
		}
	}
};
</script>
